module.exports = __webpack_public_path__ + "static/media/kakao.b48cff3f.png";